<template>
    <div v-wechat-title="title">
        <el-row type="flex" align="middle">
            <el-col class="align-left" :span="1.5">
                <span>手术时间：</span>
            </el-col>
            <el-col class="align-left" :span="4"><item-input type="daterange" v-model="rdate"></item-input> </el-col>
            <el-col class="align-left" style="padding-left: 10px" :span="12">
                <span>手术类型：</span>
                <item-input type="select" v-model="surgery_type" :options="surgeryTypes" placeholder="手术类型" style="display: inline-block; width: 120px" :clearable="false"></item-input>
                <span>术前诊断：</span>
                <item-input type="string" placeholder="术前诊断" v-model="plan_diseases" style="display: inline-block; width: 140px" :clearable="true"></item-input>
                <span>术后诊断：</span>
                <item-input type="string" placeholder="术后诊断" v-model="fact_diseases" style="display: inline-block; width: 140px" :clearable="true"></item-input>
            </el-col>

            <el-col :span="6" class="align-right">
                <el-button type="primary" size="mini" @click="query"> 查询</el-button>
                <el-button type="primary" size="mini" @click="clearAllQueryItems"> 清空全部条件</el-button>
                <el-button type="primary" size="mini" icon="el-icon-star-off" @click="saveAsLink"> 另存为</el-button>
                <el-button type="primary" size="mini" @click="exportExcel">导出Excel</el-button>
            </el-col>
        </el-row>
        <div class="align-left" style="overflow: hidden">
            <label class="fg-info">快捷查询：</label>
            <el-tag effect="light" v-for="(l, index) in links" :key="index" closable type="info" size="small" class="margin5" @close="removeLink(l)" @click="activeLink(l)">
                <span class="fg-info">{{ l.name }}</span>
            </el-tag>
        </div>
        <div class="align-left" style="max-height: 65px; overflow: auto">
            <label class="fg-info">查询条件：</label>
            <template v-if="condition_ends.length > 0">
                <el-tag v-for="c in condition_ends" :key="c.___index" :closable="c.isCondition" type="info" size="small" class="margin5" @close="removeCondition(c.___index)">
                    <span class="fg-info">{{ c.label }}</span>
                </el-tag>
            </template>
            <span v-else class="fg-info">请添加查询条件</span>
        </div>
        <list-view
            :showSequence="false"
            :selection="false"
            ref="advanced-list"
            :datalist="conditions"
            :tableHeight="this.screenHeight - 222"
            :stripe="false"
            :columns="columnList"
            :buttons="buttons"
            @extrabutton-click="extraButtonClick"
        >
            <div slot="c_operator" class="ellipsis" slot-scope="{ row }">
                <item-input type="select" v-model="row.c_operator" :options="row.c_operator_options"> </item-input>
            </div>
            <div slot="c_right_value" class="ellipsis" slot-scope="{ row }">
                <item-input v-if="row.alias == 'date'" type="datetime" v-model="row.c_right_value"></item-input>
                <item-input v-else-if="row.alias == 'text'" type="string" v-model="row.c_right_value"></item-input>
                <item-input v-else-if="row.alias == 'float'" type="float" v-model="row.c_right_value"></item-input>
                <item-input
                    v-else-if="row.alias && row.alias.substring(0, 5) == 'enum|'"
                    type="multiselect"
                    :showCount="3"
                    :collapseTags="false"
                    :config="{ collapseTags: false }"
                    v-model="row.c_right_value"
                    :options="row.c_right_options"
                ></item-input>
                <item-input v-else-if="row.alias == 'bit'" type="select" v-model="row.c_right_value" options="enum_bool"></item-input>
                <item-input v-else type="string" v-model="row.c_right_value"></item-input>
            </div>
            <div slot="c_right_value2" class="ellipsis" slot-scope="{ row }">
                <div v-if="row.c_operator && row.c_operator == 'Between'">
                    <item-input v-if="row.alias == 'date'" type="datetime" v-model="row.c_right_value2"></item-input>
                    <item-input v-else-if="row.alias == 'text'" type="string" v-model="row.c_right_value2"></item-input>
                    <item-input v-else-if="row.alias == 'float'" type="float" v-model="row.c_right_value2"></item-input>
                    <item-input
                        v-else-if="row.alias && row.alias.substring(0, 5) == 'enum|'"
                        type="multiselect"
                        v-model="row.c_right_value2"
                        :options="row.c_right_options"
                        :showCount="3"
                        :collapseTags="false"
                        :config="{ collapseTags: false }"
                        placeholder="值"
                        style="display: inline-block; width: 160px"
                    ></item-input>
                    <item-input v-else-if="row.alias == 'bit'" type="select" v-model="row.c_right_value2" options="enum_bool"></item-input>
                    <item-input v-else type="string" v-model="row.c_right_value2"></item-input>
                </div>
            </div>
        </list-view>
        <el-drawer key="drawer1" :visible.sync="drawerVisible" :with-header="false" direction="rtl">
            <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 100%; background: white">
                <template v-for="(item, index) in documentList">
                    <div v-if="item.hasChildren" :key="index" class="padding10">
                        <div class="title align-left padding5">
                            <el-link @click="gotoDocument(item)"
                                ><span class="el-icon-document"></span><b>{{ item.label }}</b></el-link
                            >&nbsp;&nbsp;({{ item.children.length }})
                        </div>
                        <div class="padding20 padding-none-v">
                            <div v-for="c in item.children" :key="c.index" class="align-left cursor-pointer" @click="loadInstance(c)">
                                {{ c.label }} &nbsp;&nbsp;<span class="fg-info">{{ c.createby }}</span> &nbsp;&nbsp;&nbsp;&nbsp;
                                <span>
                                    <font-awesome-icon :icon="['fas', 'lock']" class="fg-warning" v-if="c.archiveddt"></font-awesome-icon>
                                    <font-awesome-icon :icon="['fas', 'lock-open']" class="fg-warning" v-else></font-awesome-icon>
                                </span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-scrollbar>
        </el-drawer>
        <el-drawer key="drawer2" :visible.sync="drawerVisible2" :with-header="false" direction="rtl">
            <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 100%; background: white">
                <template v-if="filterDocumentList.length > 0">
                    <div :key="index" class="padding10" v-for="(item, index) in filterDocumentList">
                        <div class="title align-left padding5">
                            <span class="el-icon-document"></span><b>{{ item.label }}</b
                            >&nbsp;&nbsp;({{ item.children.length }})
                        </div>
                        <div class="padding20 padding-none-v">
                            <div v-for="c in item.children" :key="c.index" class="align-left cursor-pointer" @click="loadInstance(c)">
                                {{ c.label }} &nbsp;&nbsp;<span class="fg-info">{{ c.createby }}</span>
                            </div>
                        </div>
                    </div>
                </template>
                <span v-else>暂无记录</span>
            </el-scrollbar>
        </el-drawer>
        <cus-dialog class="document-medicalrecord" :title="document.title" :visible.sync="document.dialogFormVisible" width="60%" :footerVisible="false">
            <DocFrame v-if="document.docno > 0" ref="doc" :docno="document.docno" :docbizid="document.docbizid" :surgeryId="surgeryId"></DocFrame>
            <div v-else style="min-height: 600px" v-loading="loading">
                <pdf v-for="i in numPages" :key="i" :src="src" :page="i"></pdf>
            </div>
        </cus-dialog>
        <el-dialog title="查询结果" :close-on-click-modal="false" :show-close="false" :visible.sync="advancedquery.visible" class="table-h560" width="90%">
            <ListView
                ref="surgery-list"
                :datalist="advancedquery.data"
                v-loading="loadingText"
                element-loading-text="加载中..."
                :columns="allColumns"
                :buttons="advancedquery.buttons"
                @extrabutton-click="extraButtonClick"
            ></ListView>
            <el-pagination
                class="align-left"
                background
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="query"
                @current-change="query"
                :page-sizes="[10, 20, 50, 100, 200]"
                :current-page.sync="currentPage"
                :page-size.sync="pageSize"
                :total="total"
            >
            </el-pagination>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="exportExcel">导出Excel</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import FileSaver from "file-saver"
import XLSX from "xlsx"
import { mapGetters } from 'vuex'
import pdf from '@/common/vue-pdf-4.1.0'
import axios from 'axios'
export default {
    name: `AdvancedQuery`,
    components: { pdf },
    props: {},
    data() {
        return {
            title: `科研综合查询`,
            buttons: [
                {
                    label: `新增`,
                    type: `primary`,
                    emit: `addRow`,
                    permission: `default`
                },
                {
                    label: `删除`,
                    type: `primary`,
                    emit: `deleteRow`,
                    permission: `default`
                }
            ],
            rdate: [
                this.$moment()
                    .add(-6, `days`)
                    .format(`YYYY/MM/DD`),
                this.$moment()
                    .add(1, `days`)
                    .format(`YYYY/MM/DD 23:59:59`)
            ],
            o_dic_operating_ward_id: undefined,
            issetoperatingward: false,
            documentList: [],
            surgeryId: undefined,
            drawerVisible: false,
            drawerVisible2: false,
            document: {
                title: ``,
                dialogFormVisible: false,
                docno: ``,
                docbizid: ``
            },
            src: undefined,
            numPages: 0,
            loading: false,
            checkedRow: [],
            is_sealed: false,
            ward_id: undefined,
            query_conditions: [],
            query_conditions_buttons: [
                {
                    label: `删除`,
                    type: `danger`,
                    emit: `remove`,
                    permission: `default`
                }
            ],
            c_condition: ``,
            c_operator: ``,
            c_right_value: ``,
            conditions: [],
            link_name: ``,
            links: [],
            currentPage: 1,
            pageSize: 50,
            total: 0,
            surgery_type: 0,
            plan_diseases: null,
            fact_diseases: null,
            advancedquery: {
                visible: false,
                data: [],
                columnList: [{
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    width: `120`,
                    isListable: true,
                    isExpand: false,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`advanced_query.visit_no`),
                    width: `120`,
                    isListable: true,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    width: `60`,
                    isListable: true,
                    sortable: false
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    width: `60`,
                    isListable: true,
                    sortable: false
                },
                {
                    type: `datetime`,
                    prop: `in_room_time`,
                    label: `手术时间`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgery_type`,
                    label: `手术类型`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `已施手术`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `plan_diseases`,
                    label: `术前诊断`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `fact_diseases`,
                    label: `术后诊断`,
                    isListable: true
                },

                {
                    type: `string`,
                    prop: `surgeon`,
                    label: `实际手术医生`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anes_doctor`,
                    label: `实际麻醉医生`,
                    width: `80`,
                    isListable: true
                }]
                // buttons: [
                //     {
                //         label: `患者数据`,
                //         type: `primary`,
                //         emit: `gotoSurgeryInfo`,
                //         permission: `default`
                //     }]
            },
            loadingText: null,
            o_allColumns: []
        }
    },
    created() {
        this.loadInitConditions()
    },
    mounted() {
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.loadLinks()
    },
    computed: {
        ...mapGetters([`ward_auth`, `operation_ward_auth`, `workbar`, `business`, `currentUser`, `sys_enums`, `screenWidth`, `screenHeight`, `active_ward`]),
        queryItems() {
            let r = _.reduce(
                this.sys_enums.QueryMessageType,
                (result, v, index) => {
                    let r = { ...v }
                    r.children = _.orderBy(this.sys_enums[r.alias], `display_order`)
                    result.push(r)
                    return result
                },
                []
            )
            return r
        },
        surgeryTypes() {
            var r = _.map(this.sys_enums && this.sys_enums.Enum_SurgeryType, d => {
                return {
                    value: d.value,
                    label: d.label
                }
            })
            return [{ value: 0, label: `全部类型` }].concat(r)
        },
        operators() {
            let a = _.map(this.sys_enums.Operators || [], d => {
                d.value = d.alias
                return d
            })
            return a
        },
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        allColumns: {
            get: function() {
                if (this.o_allColumns.length == 0) {
                    this.o_allColumns = [...this.advancedquery.columnList]
                }
                return this.o_allColumns
            },
            set: function(v) {
                this.o_allColumns = v
            }
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `___index`,
                    label: `unique`,
                    isKey: true
                },
                {
                    type: `select`,
                    prop: `enum_and_or_relation`,
                    label: `多项查询`,
                    width: `80`,
                    isListable: true,
                    config: {
                        clearable: false
                    },
                    options: [
                        { value: 1, label: `And` },
                        { value: 2, label: `Or` }
                    ]

                },
                {
                    type: `cascader`,
                    prop: `c_condition`,
                    label: `项目`,
                    width: `300`,
                    editable: true,
                    isListable: true,
                    isExpand: false,
                    sortable: false,
                    options: this.queryItems,
                    change: (that, { index, row, prop, column }) => {
                        let group = _.find(this.queryItems, { value: row.c_condition[0] })
                        let item = (group && _.find(group.children, { value: row.c_condition[1] })) || {}
                        let r = { ...item }
                        let rightoptions = (r.alias && r.alias.substring(0, 5) == `enum|` && this.sys_enums[r.alias.replace(`enum|`, ``)]) || []
                        this.$set(row, `c_right_options`, rightoptions)
                        this.$set(row, `c_operator_options`, this.getOperatorOptionsByType(r.alias))
                        this.$set(row, `alias`, r.alias)
                        this.$set(row, `c_operator`, `Equal`)
                        if (r.alias == `date`) {
                            this.$set(row, `c_right_value`, this.$moment().format(`YYYY/MM/DD 00:00`))
                        } else if (r.alias == `text`) {
                            this.$set(row, `c_right_value`, ``)
                        } else if (r.alias == `float`) {
                            this.$set(row, `c_right_value`, 0)
                        } else if (r.alias == `bit`) {
                            this.$set(row, `c_right_value`, true)
                        } else if (r.alias && r.alias.substring(0, 5) == `enum|`) {
                            this.$set(row, `c_operator`, `In`)
                        } else {
                            this.$set(row, `c_right_value`, ``)
                        }
                        if (group && group.label == `生命体征` && r.alias == `float`) {
                            this.$set(row, `c_operator`, `Between`)
                            this.$set(row, `c_right_value`, 0)
                            this.$set(row, `c_right_value2`, 0)
                        }
                    }
                },
                {
                    type: `custom`,
                    prop: `c_operator`,
                    label: `运算`,
                    width: `280`,
                    isListable: true,
                    sortable: false
                },
                {
                    type: `custom`,
                    prop: `c_right_value`,
                    label: `值1`,
                    isListable: true,
                    sortable: false
                },
                {
                    type: `custom`,
                    prop: `c_right_value2`,
                    label: `值2`,
                    isListable: true,
                    sortable: false
                }

            ]
        },
        filterDocumentList() {
            return _.filter(this.documentList, d => d.children.length > 0)
        },
        condition_ends() {
            let r = _.reduce(
                this.conditions,
                (result, v, index) => {
                    if (v.isCondition) {
                        let r = { ...v }
                        if (index != 0) {
                            result.push({
                                label: `${r.enum_and_or_relation == 1 ? `And` : `Or`}`
                            })
                        }
                        result.push(r)
                    }
                    return result
                },
                []
            )
            return r
        }
    },
    methods: {
        extraButtonClick(target) {
            this[target.emit] && this[target.emit](target)
        },
        newItem(index) {
            let item = {
                ___index: _.now() + (index + 1) * 1000,
                enum_and_or_relation: 1,
                alias: `text`,
                c_condition: null,
                c_operator: `Equal`,
                c_operator_options: this.getOperatorOptionsByType(`text`),
                c_right_value: null,
                c_right_options: null,
                c_right_value2: null,
                active: true,
                isCondition: false,
                enum_query_message_type: null,
                query_operator: null,
                query_message: null,
                left_name: null,
                left_value: null,
                right_value: null,
                label: ``
            }
            return item
        },
        loadInitConditions() {
            for (let index = 0; index < 5; index++) {
                let item = this.newItem(index)
                this.conditions.push(item)
            }
        },
        getOperatorOptionsByType(type) {
            let options = []
            switch (type) {
            case `text`:
                options = [
                    { label: `=`, value: `Equal` },
                    { label: `!=`, value: `NotEqual` },
                    { label: `包含字符`, value: `Like` },
                    { label: `不包含字符`, value: `NotLike` }
                ]
                break
            case `float`:
            case `date`:
                options = [
                    { label: `=`, value: `Equal` },
                    { label: `>`, value: `GreaterThan` },
                    { label: `<`, value: `LessThan` },
                    { label: `>=`, value: `GreaterThanOrEqual` },
                    { label: `<=`, value: `LessThanOrEqual` },
                    { label: `区间内`, value: `Between` }
                ]
                break
            case `bit`:
                options = [
                    { label: `=`, value: `Equal` }
                ]
                break
            default:
                options = [
                    { label: `=`, value: `Equal` },
                    { label: `>`, value: `GreaterThan` },
                    { label: `<`, value: `LessThan` },
                    { label: `>=`, value: `GreaterThanOrEqual` },
                    { label: `<=`, value: `LessThanOrEqual` },
                    { label: `包含指定值`, value: `In` },
                    { label: `不包含指定值`, value: `NotIn` },
                    { label: `区间内`, value: `Between` }
                ]
                break
            }
            if (type && type.substring(0, 5) == `enum|`) {
                options = [
                    { label: `包含指定值`, value: `In` }
                ]
            }
            return options
        },
        getHeaderConditions() {
            let conditions = []

            let group = _.find(this.queryItems, { label: `事件时间` })
            let item = (group && _.find(group.children, { label: `进手术间` })) || {}
            let parent = group && group.value
            let child = item && item.value

            if (this.rdate[0]) {
                let operateBegin = {
                    ___index: _.now(),
                    enum_and_or_relation: 1,
                    alias: `date`,
                    c_condition: [parent, child],
                    c_operator: `GreaterThanOrEqual`,
                    c_right_value: this.rdate[0],
                    isCondition: true,
                    enum_query_message_type: parent,
                    query_operator: `GreaterThanOrEqual`,
                    query_message: `进手术间`,
                    left_name: item.code,
                    left_value: child,
                    right_value: this.rdate[0]
                }

                conditions.push(operateBegin)
            }

            if (this.rdate[1]) {
            // 手术结束时间 结束
                let operateEnd = {
                    ___index: _.now(),
                    enum_and_or_relation: 1,
                    alias: `date`,
                    c_condition: [parent, child],
                    c_operator: `LessThanOrEqual`,
                    c_right_value: this.rdate[1],
                    isCondition: true,
                    enum_query_message_type: parent,
                    query_operator: `LessThanOrEqual`,
                    query_message: `进手术间`,
                    left_name: item.code,
                    left_value: child,
                    right_value: this.rdate[1]
                }
                conditions.push(operateEnd)
            }

            // 手术类型 IN
            if (this.surgery_type !== 0) {
                let applygroup = _.find(this.queryItems, { label: `申请信息` })
                let surgerytype = (applygroup && _.find(applygroup.children, { label: `手术类型` })) || {}
                let applyparent = applygroup && applygroup.value
                let surgerytypevalue = surgerytype && surgerytype.value
                let rightValue = `1,2`
                // 手术类型
                if (this.surgery_type == 1 || this.surgery_type == 2) {
                    rightValue = this.surgery_type.toString()
                }
                let surgeryTypeCon = {
                    ___index: _.now(),
                    enum_and_or_relation: 1,
                    alias: `text`,
                    c_condition: [applyparent, surgerytypevalue],
                    c_operator: `In`,
                    c_right_value: rightValue,
                    isCondition: true,
                    enum_query_message_type: applyparent,
                    query_operator: `In`,
                    query_message: `手术类型`,
                    left_name: surgerytype.code,
                    left_value: surgerytypevalue,
                    right_value: rightValue
                }
                conditions.push(surgeryTypeCon)
            }

            if (this.plan_diseases) {
            // 诊断
                let surgerygroup = _.find(this.queryItems, { label: `手术信息` })
                let diseasName = (surgerygroup && _.find(surgerygroup.children, { label: `术前诊断` })) || {}
                let surgeryInfo = surgerygroup && surgerygroup.value
                let diseasNameValue = diseasName && diseasName.value

                let diseasCon = {
                    ___index: _.now(),
                    enum_and_or_relation: 1,
                    alias: `text`,
                    c_condition: [surgeryInfo, diseasNameValue],
                    c_operator: `Like`,
                    c_right_value: this.plan_diseases,
                    isCondition: true,
                    enum_query_message_type: surgeryInfo,
                    query_operator: `Like`,
                    query_message: `术前诊断`,
                    left_name: diseasName.code,
                    left_value: diseasNameValue,
                    right_value: this.plan_diseases
                }

                conditions.push(diseasCon)
            }

            if (this.fact_diseases) {
            // 诊断
                let bsurgerygroup = _.find(this.queryItems, { label: `手术信息` })
                let bdiseasName = (bsurgerygroup && _.find(bsurgerygroup.children, { label: `术后诊断` })) || {}
                let bsurgeryInfo = bsurgerygroup && bsurgerygroup.value
                let bdiseasNameValue = bdiseasName && bdiseasName.value

                let bdiseasCon = {
                    ___index: _.now(),
                    enum_and_or_relation: 1,
                    alias: `text`,
                    c_condition: [bsurgeryInfo, bdiseasNameValue],
                    c_operator: `Like`,
                    c_right_value: this.fact_diseases,
                    isCondition: true,
                    enum_query_message_type: bsurgeryInfo,
                    query_operator: `Like`,
                    query_message: `术后诊断`,
                    left_name: bdiseasName.code,
                    left_value: bdiseasNameValue,
                    right_value: this.fact_diseases
                }

                conditions.push(bdiseasCon)
            }

            return conditions
        },
        archive(c) {
            if (this.is_sealed) {
                this.$message.warning(`病案已封存,不允许归档操作`)
                return false
            }
            if (c.docno > 0) {
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/ArchiveInstance`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docbizid: c.docbizid, operator: this.currentUser.dic_worker_name }
                })
                req.then(data => {
                    // 保存无纸化记录,文书3.2.6才会支持Content数据返回[jira:ICIS-13291]
                    if (this.$root.PaperlessEnabled == 1 && data.Content && data.Content.Sysid > 0 && data.Content.ArchivedDt) {
                        let recData = {
                            biz_id: data.Content.Sysid,
                            biz_surgery_info_id: data.Content.Vid,
                            biz_type: 1, // 0麻醉单和苏醒单，1文书
                            doc_name: data.Content.DocName,
                            file_path: `${data.Content.Guid}.pdf`,
                            create_by: this.currentUser.username,
                            create_by_name: this.currentUser.dic_worker_name,
                            create_time: data.Content.ArchivedDt
                        }
                        this.myaxios.post(`api/Operation/PaperlessDocRecord/Add`, recData)
                    }

                    this.loadDocumentList()
                })
            } else if (!c.archiveddt) {
                let req = this.myaxios.put(`/api/Operation/Home/Archive?surgeryInfoId=${this.surgeryId}&&recordType=${c.index == `MZD` ? 1 : 2}`)
                req.then(data => {
                    this.loadDocumentList()
                })
            }
        },
        gotoDocument(document) {
            this.$confirm(`转到患者文书, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let r = _.find(this.business, { business_level: `M004` })
                this.$router.push(`${(r && r.url) || `/`}?surgery_id=${this.surgeryId}&&document_id=${document.docid}`)
            })
        },
        loadDocArchiveView({ row }) {
            this.is_sealed = row.is_sealed
            this.ward_id = row.dic_operating_ward_id ? `ow_${row.dic_operating_ward_id}` : `rw_${row.dic_recovery_ward_id}`
            this.drawerVisible = true
            this.surgeryId = row.id
            this.loadDocumentList()
        },
        loadDocumentList() {
            return new Promise((resolve, reject) => {
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocManagementList`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded`, 'Authorization': sessionStorage.getItem(`doctoken`) },
                    params: { deptno: `acis2020`, permission: `0-11111111111`, vid: `xxx` }
                })
                let req2 = this.myaxios.get(`/api/Operation/Home/ArchiveList?surgeryInfoId=${this.surgeryId}`)
                let req3 = this.myaxios.get(`/api/AcisSystem/DocumentConfig/Get`)
                this.myaxios.all(req, req2, req3).then(([data, data2, data3]) => {
                    this.documentList = [
                        {
                            index: `MZYFS`,
                            hasChildren: true,
                            children:
                                (data2 &&
                                    data2.map(d => {
                                        return {
                                            surgeryId: d.biz_surgery_info_id,
                                            index: d.enum_record_type == 1 ? `MZD` : `FSD`,
                                            docno: d.enum_record_type == 1 ? -1 : -2,
                                            label: d.record_type,
                                            archiveddt: d.is_archived ? d.archive_date : ``
                                        }
                                    })) ||
                                [],
                            label: `麻醉与复苏`
                        }
                    ].concat(
                        _.filter(_.orderBy(data.data, `PrintOrder`), d => {
                            let dc = _.find(data3, d3 => d3.document_id == d.DocNo)
                            return (
                                dc &&
                                _.some(dc.regions, reg => {
                                    return (reg.dic_operating_ward_id ? `ow_${reg.dic_operating_ward_id}` : `rw_${reg.dic_recovery_ward_id}`) == this.ward_id
                                })
                            )
                        }).map(dr => {
                            let d = { ...dr }
                            d.index = `${d.DocNo}`
                            d.hasChildren = d.IsSurportHtml
                            d.children = []
                            d.label = d.DocName
                            return d
                        })
                    )
                    _.forEach(this.documentList, d => {
                        if (d.hasChildren && d.DocNo > 0) {
                            this.loadInstances(d.index)
                        }
                    })
                })
            })
        },
        loadInstances(docno) {
            let submenu = _.find(this.documentList, d => {
                return d.DocNo == docno
            })
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/QueryInstances`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` },
                params: { docid: docno, dept: `acis2020`, vid: this.surgeryId }
            })
            req.then(data => {
                submenu.children = _.filter(data.Content, d => {
                    return d.istemplate == `0`
                }).map(d => {
                    d.index = `${d.docbizid}`
                    d.docno = submenu.DocNo
                    d.label = d.docname
                    return d
                })
            })
        },
        loadDocumentView({ row }) {
            this.drawerVisible2 = true
            this.ward_id = row.dic_operating_ward_id ? `ow_${row.dic_operating_ward_id}` : `rw_${row.dic_recovery_ward_id}`
            this.surgeryId = row.id
            this.loadDocumentList()
        },
        loadInstance(doc) {
            if (doc.docno > 0) {
                this.document = {
                    title: doc.label,
                    docno: doc.docno,
                    docbizid: doc.docbizid,
                    dialogFormVisible: true
                }
                this.src = undefined
                // this.document.dialogFormVisible=true
                this.$nextTick(() => {
                    this.$refs.doc.loadDocument()
                })
            } else {
                this.loading = true
                let req = this.myaxios.get(`/api/Operation/Home/ArchivePdf?surgeryInfoId=${this.surgeryId}&recordType=${doc.index == `MZD` ? 1 : 2}`)
                req.then(data => {
                    this.document = {
                        title: doc.label,
                        docno: doc.docno,
                        docbizid: doc.docbizid,
                        dialogFormVisible: true
                    }
                    // this.document.dialogFormVisible=true
                    this.src = pdf.createLoadingTask(`data:application/pdf;base64,${data}`)
                    this.src.then(content => {
                        this.numPages = content.numPages
                        this.loading = false
                    })
                }).catch(e => {
                    console.log(e)
                    this.loading = false
                })
            }
        },
        cancel() {
            this.loadingText = false
            this.allColumns = []
            this.advancedquery.data = []
            this.advancedquery.visible = false
            this.currentPage = 1
            this.total = 0
            this.pageSize = 50
        },
        exportExcel() {
            let that = this
            this.$nextTick(function() {
                var table = that.$refs[`surgery-list`].$refs[`cus-table`].$el
                var fileName = `科研综合查询_` + new Date().toLocaleDateString() + `.xlsx`
                var wb = XLSX.utils.table_to_book(table)
                /* get binary string as output */
                var wbout = XLSX.write(wb, {
                    bookType: `xlsx`,
                    bookSST: true,
                    type: `array`
                })
                try {
                    FileSaver.saveAs(
                        new Blob([wbout], { type: `application/octet-stream` }),
                        fileName
                    )
                } catch (e) {
                    console.log(e, wbout)
                }
                return wbout
            })
        },
        getAllConditions(transBetween) {
            let tmpconditions = []
            _.forEach(this.conditions, d => {
                this.addCondition(d)
            })
            let conditions = _.filter(this.conditions, d => d.isCondition)
            let headerConds = this.getHeaderConditions()
            let all = headerConds.concat(conditions)
            tmpconditions = _.reduce(
                all,
                (result, val, index) => {
                    let v = { ...val }
                    if (val.c_operator == `Between` && transBetween === true) {
                        v.query_operator = `GreaterThanOrEqual`
                        v.c_operator = `GreaterThanOrEqual`

                        result.push(v)
                        let v1 = { ...v }
                        v1.query_operator = `LessThanOrEqual`
                        v1.c_operator = `LessThanOrEqual`
                        v1.c_right_value = v.c_right_value2
                        v1.right_value = v.c_right_value2
                        result.push(v1)
                    } else {
                        if (val.alias && val.alias.substring(0, 5) == `enum|`) {
                            v.c_right_value = _.join(val.c_right_value, `,`)
                            v.right_value = _.join(val.c_right_value, `,`)
                        }
                        result.push(v)
                    }
                    return result
                }, []
            )
            return tmpconditions
        },
        clearAllQueryItems() {
            this.conditions = []
            this.loadInitConditions()
        },
        addCondition(row) {
            if (!row.c_condition || row.c_condition == `` || row.c_condition.length == 0) {
                return
            } else if (!row.c_operator || row.c_operator.length == 0) {
                return
            } else if (row.c_right_value == null || row.c_right_value.length == 0 || row.c_right_value === ``) {
                return
            }
            let group = _.find(this.queryItems, { value: row.c_condition[0] })
            let item = (group && _.find(group.children, { value: row.c_condition[1] })) || {}
            let queryItemType = { ...item }
            queryItemType.group_alias = group && group.alias
            queryItemType.group_value = group && group.value
            let operator = _.find(this.operators, { value: row.c_operator })
            let rightValue = row.c_right_value
            if (queryItemType.alias.substring(0, 5) == `enum|`) {
                let vo = _.reduce(
                    this.sys_enums[queryItemType.alias.replace(`enum|`, ``)],
                    function(result, val, index) {
                        result[val.value] = val.label
                        return result
                    },
                    {}
                )
                rightValue = _.map(rightValue, d => {
                    return vo[d]
                })
            }
            row.isCondition = true
            row.enum_query_message_type = queryItemType.group_value
            // 3 手术信息 query_message=拟施手术名称、术前诊断、拟施麻醉方式、计划主刀医生、计划麻醉医生
            if (queryItemType.group_value == 3) {
                if (queryItemType.label == `拟施手术` ||
                queryItemType.label == `术前诊断` ||
                queryItemType.label == `计划麻醉方式` ||
                queryItemType.label == `计划手术医生` ||
                queryItemType.label == `计划麻醉医生`
                ) {
                    row.isfact = false
                    row.alias_name = `plan_` + queryItemType.code
                } else {
                    row.isfact = true
                    row.alias_name = `fact_` + queryItemType.code
                }
            }

            row.query_operator = row.c_operator
            row.query_message = queryItemType.label
            row.left_name = queryItemType.code
            row.left_value = queryItemType.value
            row.right_value = row.c_right_value
            row.enum_and_or_relation = row.enum_and_or_relation
            if (row.c_operator == `Between`) {
                row.label = `【${queryItemType.label}】在 '${row.c_right_value}' 到'${row.c_right_value2}' 区间内`
            } else {
                row.label = `【${queryItemType.label}】${operator && operator.label}'${rightValue}'`
            }
        },
        removeCondition(index) {
            let idx = _.findIndex(this.conditions, i => {
                return i.___index == index
            })
            if (idx > -1) {
                this.conditions.splice(idx, 1)
            }
            if (this.conditions.length == 0) {
                this.loadInitConditions()
            }
        },
        query() {
            let that = this
            that.loadingText = true
            let clientIp = sessionStorage.getItem(`clientIp`)
            if (!clientIp || clientIp === `undefined` || clientIp === `null`) {
                clientIp = ``
            }

            let token = sessionStorage.getItem(`token`)
            let authorization = `bearer ${token}`
            if (!token || token === `undefined` || token === `null`) {
                authorization = undefined
            }

            let tmpconditions = this.getAllConditions(true)
            let req = that.axios.post(`api/Operation/AdvanceQuery/Get?pageIndex=${this.currentPage}&pageSize=${this.pageSize}`, tmpconditions, { headers: {
                'Authorization': authorization,
                'clientIp': clientIp
            },
            emulateJSON: true }, false)
            let conditions = _.filter(this.conditions, d => d.isCondition)
            if (conditions && conditions.length > 0) {
                this.allColumns = []
                let transColumns = this.conditionTranToColumns(conditions)
                this.allColumns.splice(6, 0, ...transColumns)
                console.log(`插入动态列后的列`, this.allColumns)
            }

            req.then(res => {
                this.total = res.count
                let data = res.data
                let r = _.map(data, d => {
                    if (d.extra_datas && d.extra_datas.length > 0) {
                        _.forEach(d.extra_datas, b => {
                            if (b.DataValue && (b.DataValue.toLowerCase() == `false` || b.DataValue.toLowerCase() == `true`)) { b.DataValue = b.DataValue.toLowerCase() == `true` }
                            d[b.DataKey] = b.DataValue
                        })
                    }
                    d.is_sealed = !!d.is_sealed
                    return d
                })
                that.loadingText = false
                console.log(`extralData转换后的列extralData转换后的列`, r)
                this.advancedquery.data = r
            }).catch(e => {
                console.log(e)
                that.loadingText = false
            }
            )
            this.advancedquery.visible = true
        },
        addRow({ emit, index, row }) {
            let item = this.newItem(index)
            this.conditions.splice(index + 1, 0, item)
        },
        deleteRow({ emit, index, row }) {
            this.conditions.splice(index, 1)
            if (this.conditions.length == 0) {
                this.loadInitConditions()
            }
        },
        loadLinks() {
            let req = this.myaxios.get(`/api/AcisSystem/QueryConfig/Get`)
            req.then(data => {
                this.links = data
            })
        },
        saveAsLink() {
            let tmpconditions = this.getAllConditions(false)
            tmpconditions = _.filter(tmpconditions, d => d.active == true)
            if (tmpconditions.length == 0) {
                this.$message.warning(`请添加查询条件`)
                return
            }

            this.$prompt(`请输入快捷方式名称`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                inputPattern: /.+/,
                inputErrorMessage: `不能为空`
            })
                .then(({ value }) => {
                    let req = this.myaxios.post(`api/AcisSystem/QueryConfig/Post`, {
                        name: value,
                        details: _.map(tmpconditions, (d, index) => {
                            let r = { ...d }
                            r.right_value1 = d.c_right_value2
                            r.display_order = index + 1
                            return r
                        })
                    })
                    req.then(() => {
                        this.loadLinks()
                    })
                })
                .catch(e => console.log(e))
        },
        removeLink(l) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.delete(`api/AcisSystem/QueryConfig/Delete/${l.id}`)
                req.then(data => {
                    this.loadLinks()
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        activeLink(l) {
            this.conditions = _.map(l.details, (d, index) => {
                let conds = this.newItem(index)
                conds.c_condition = [d.enum_query_message_type, parseInt(d.left_value)]
                conds.enum_and_or_relation = d.enum_and_or_relation

                let operator = _.find(this.sys_enums.Operators, { alias: d.query_operator })
                let group = _.find(this.queryItems, { value: conds.c_condition[0] })
                let item = (group && _.find(group.children, { value: conds.c_condition[1] })) || {}
                conds.alias = item.alias
                conds.c_operator = d.query_operator

                conds.c_operator_options = this.getOperatorOptionsByType(conds.alias)
                conds.c_right_value = conds.alias && conds.alias.substring(0, 5) == `enum|` ? d.right_value.split(`,`) : d.right_value
                conds.c_right_options = (conds.alias && conds.alias.substring(0, 5) == `enum|` && this.sys_enums[conds.alias.replace(`enum|`, ``)]) || []
                conds.active = true
                conds.isCondition = true
                conds.enum_query_message_type = d.enum_query_message_type
                conds.query_operator = d.query_operator
                conds.query_message = d.query_message
                conds.left_name = d.left_name
                conds.left_value = d.left_value
                conds.right_value = d.right_value
                conds.c_right_value2 = d.right_value1
                conds.label = `【${d.query_message}】${operator && operator.label}'${d.right_value}'`
                if (conds.c_operator == `Between`) {
                    conds.label = `【${operator && operator.label}】在 '${conds.c_right_value}' 到'${conds.c_right_value2}' 区间内`
                } else {
                    conds.label = `【${d.query_message}】${operator && operator.label}'${d.right_value}'`
                }
                return conds
            })
            this.query()
        },
        conditionTranToColumns(conditions) {
            let extendColumns = []
            console.log(`哪些列要转换`, conditions)
            _.forEach(conditions, c => {
                let existColumn = this.advancedquery.columnList.findIndex(i => i.label == c.query_message || c.query_message == `姓名`)
                if (existColumn == -1) {
                    let column = {}
                    if (c.left_name == `Dic_PhysioParam_Id`) {
                        column = {
                            type: `string`,
                            prop: c.query_message,
                            label: c.query_message,
                            width: `140`,
                            isListable: true,
                            sortable: false
                        }
                    } else {
                        if (c.alias == `bit`) {
                            column = {
                                type: `select`,
                                options: `enum_bool`,
                                prop: c.left_name,
                                label: c.query_message,
                                width: `140`,
                                isListable: true,
                                readonly: true,
                                sortable: false
                            }
                        } else if (c.alias && c.alias.substring(0, 5) == `enum|`) {
                            let options = c.c_right_options.map(op => {
                                let o = {
                                    label: op.label,
                                    value: op.value
                                }
                                return o
                            })
                            column = {
                                type: `select`,
                                options: options,
                                prop: c.left_name,
                                label: c.query_message,
                                width: `140`,
                                isListable: true,
                                readonly: true,
                                sortable: false
                            }
                        } else {
                            column = {
                                type: `string`,
                                prop: c.alias_name || c.left_name,
                                label: c.query_message,
                                width: `140`,
                                isListable: true,
                                sortable: false
                            }
                        }
                    }
                    if (column.label == `进手术间`) {
                        column.prop = `in_room_time`
                        column.type = `datetime`
                    }
                    extendColumns.push(column)
                }
            })

            return extendColumns
        }
    },
    watch: {
    }
}
</script>
<style  lang="less">
.document-medicalrecord .el-dialog__body {
    padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Medicalrecord/AdvancedQuery.vue